import { render } from "./PaymentMethodLogo.vue?vue&type=template&id=26ecb42a&scoped=true&ts=true"
import script from "./PaymentMethodLogo.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodLogo.vue?vue&type=script&lang=ts"

import "./PaymentMethodLogo.vue?vue&type=style&index=0&id=26ecb42a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ecb42a"]])

export default __exports__